import React, { useEffect, useState } from "react";
import { post, put, get } from "../../../helpers/api_helper";
//redux
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Col, Form, Input, Label, Row } from "reactstrap";
import Loader from "common/loader";
import { Trans } from "react-i18next";
import Breadcrumb from "components/Common/Breadcrumb";
import { UPDATE_MODULE, ADD_MODULE, LANGUAGES_SEARCH, SHOW_MODULE } from "helpers/api_endpoints";

const AddModule = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [id, setId] = useState('');
    const [status, setStatus] = useState(0);
    const [name, setName] = useState('');
    const [titled, setTitled] = useState([]);
    const [title, setTitle] = useState('');
    const [languages, setLanguages] = useState([]);
    const [currentVersion, setCurrentVersion] = useState('');

    useEffect(() => {
        setId(location.state ? location.state.id : '');
        post(`${LANGUAGES_SEARCH}`,{status:1})
            .then(response => {
                setLanguages(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.log(error)
            })

        const state = location.state;
        if(state && state != undefined)
        {
            get(`${SHOW_MODULE}/${location.state.id}`)
                .then(response => {
                    const module = response.data;
                    setName(module.name);
                    setTitle(JSON.stringify(module.title));
                    setTitled(module.titled);
                    setCurrentVersion(module.currentVersion);
                    setStatus(module.status);
                    setLoading(false);
                })
                .catch(error => {
                    console.log(error)
                })

        }
    }, []);

    const handleSubmit = () => {
        if(id == '')
        {
            post(ADD_MODULE, {name, title, status, currentVersion })
                .then(response => {
                    if (response.code == 201) {
                        navigate('/modules', { state: { successMsg: 'Added SuccessFully' } });
                    }
                })

        }
        else
        {
            put(UPDATE_MODULE, { id, name, title, status, currentVersion })
                .then(response => {
                    if (response.code == 200) {
                        navigate('/modules', { state: { successMsg: 'Updated SuccessFully' } });
                    }
                })

        }
    }

    const handleToggleCheckBoxStatus = () => {
        if (status) {
            setStatus(0);
        }
        else {
            setStatus(1)
        }
    }
    
    const handleName = (languageId,value) => {
        if(titled.title == undefined)
        {
            setTitled({"title":[]})
        }
        const ln = titled.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            titled.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setTitle(JSON.stringify(titled));             
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumb title="Modules" breadcrumbItem="Add / Edit Module" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                            <Row>
                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Name</Trans></Label>
                                                    <Input
                                                        name="title"
                                                        value={name}
                                                        className="form-control"
                                                        placeholder="Enter Name"
                                                        type="text"
                                                        onChange={(e) => setName(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                {
                                                    languages.map((language, index) => (
                                                        <Row key={index}>
                                                        <div className="form-group col-md-4 mt-2">
                                                            <Label className="form-label"><Trans>Title ({language.name})</Trans></Label>
                                                            <Input
                                                                name="name"
                                                                value={titled.title?.find(el => {return el[language.id]})?titled.title?.find(el => {return el[language.id]})[language.id]:''}
                                                                className="form-control"
                                                                placeholder="Enter  Name"
                                                                type="text"
                                                                onChange={(e) => handleName(language.id,e.target.value)}
                                                                required={language.id==1||language.id==2?true:false} 
                                                                ></Input>
                                                        </div>
                                                    </Row>
                                                    ))
                                                }

                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Current Version</Trans></Label>
                                                    <Input
                                                        name="title"
                                                        value={currentVersion}
                                                        className="form-control"
                                                        placeholder="Enter Current Version"
                                                        type="text"
                                                        onChange={(e) => setCurrentVersion(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Status</Trans></Label>
                                                    <div className="form-check form-check-end">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="defaultCheck2"
                                                            checked={status == 1}
                                                            onClick={handleToggleCheckBoxStatus}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="defaultCheck2"
                                                        >
                                                            <Trans>Active</Trans>
                                                        </label>
                                                    </div>
                                                </div>


                                                <div className="text-center  mt-4">
                                                    <Button type="submit" color="danger">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AddModule;